module.exports = __webpack_public_path__ + "acceptancemark-paymentmethod-3.493affa0.svg";